import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { useCheckboxGroup } from './use-checkbox-group.esm.js';
import { __DEV__ } from '../../utils/assertion.esm.js';
import { createContext } from '../../utils/react-helpers.esm.js';

var _createContext = createContext({
    name: 'CheckboxGroupContext',
    strict: false
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  CheckboxGroupProvider = _createContext2[0],
  useCheckboxGroupContext = _createContext2[1];

/**
 * Used for multiple checkboxes which are bound in one group,
 * and it indicates whether one or more options are selected.
 *
 */
var CheckboxGroup = function CheckboxGroup(props) {
  var state = props.state,
    size = props.size,
    variant = props.variant,
    children = props.children,
    disabled = props.disabled;
  var _useCheckboxGroup = useCheckboxGroup(props),
    value = _useCheckboxGroup.value,
    onChange = _useCheckboxGroup.onChange;
  var group = useMemo(function () {
    return {
      size: size,
      onChange: onChange,
      state: state,
      value: value,
      variant: variant,
      disabled: disabled
    };
  }, [state, size, onChange, value, variant, disabled]);
  return /*#__PURE__*/React.createElement(CheckboxGroupProvider, {
    value: group
  }, children);
};
if (__DEV__) {
  CheckboxGroup.displayName = 'CheckboxGroup';
}

export default CheckboxGroup;
export { useCheckboxGroupContext };
//# sourceMappingURL=checkbox-group.esm.js.map
